import { reactive, watch } from "vue";

// One open/closed flag shared by every page, so the assistant stays open
// while navigating and after a refresh (per browser tab).
const storage_key = "ai_campus_vsi_assistant_open";

function read_saved_open_state() {
  try {
    return sessionStorage.getItem(storage_key) === "1";
  } catch {
    return false;
  }
}

export const assistant_panel_state = reactive({
  is_open: read_saved_open_state(),
});

watch(
  () => assistant_panel_state.is_open,
  (is_open) => {
    try {
      sessionStorage.setItem(storage_key, is_open ? "1" : "0");
    } catch {
      // Storage can be unavailable; the panel still works for this page.
    }
  }
);

// Pages use `showAssistant` in their templates; this maps it to the shared flag.
export const assistant_panel_mixin = {
  computed: {
    showAssistant: {
      get() {
        return assistant_panel_state.is_open;
      },
      set(is_open) {
        assistant_panel_state.is_open = is_open;
      },
    },
  },
};
